import { render } from "./TicketDetailModal.vue?vue&type=template&id=f474f668&scoped=true"
import script from "./TicketDetailModal.vue?vue&type=script&lang=js"
export * from "./TicketDetailModal.vue?vue&type=script&lang=js"

import "./TicketDetailModal.vue?vue&type=style&index=0&id=f474f668&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f474f668"]])

export default __exports__